/* Registrace člena – rozbalení polí „jaké / období" po zaškrtnutí členství.
 * Bez JS zůstanou bloky skryté (atribut hidden), formulář ale funguje – pole jsou nepovinná. */
(function () {
	function init() {
		var prepinace = document.querySelectorAll('[data-toggle]');
		Array.prototype.forEach.call(prepinace, function (ch) {
			var blok = document.querySelector('[data-toggle-blok="' + ch.getAttribute('data-toggle') + '"]');
			if (!blok) return;
			ch.addEventListener('change', function () {
				blok.hidden = !ch.checked;
			});
		});
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
